module.exports = __webpack_public_path__ + "img/livecoding.c11b015a.svg";